import styles from './index.module.scss';
import ImgCover from '@/assets/productCenter/phonics/ability-cover.png';
import IconAbility1 from '@/assets/productCenter/phonics/ability-icon-1.png';
import IconAbility2 from '@/assets/productCenter/phonics/ability-icon-2.png';
import IconAbility3 from '@/assets/productCenter/phonics/ability-icon-3.png';
import IconAbility4 from '@/assets/productCenter/phonics/ability-icon-4.png';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';

const ABILITY_LIST = [
  {
    icon: IconAbility1,
    title: '感知力',
    desc: '实时语音交互+答题过程追踪，识别孩子的真实理解程度与思维断点。',
    class: styles['screen3-ability-1'],
  },
  {
    icon: IconAbility2,
    title: '决策力',
    desc: '基于学情数据自主决策——下一步是追问、提示、拆解还是迁移。',
    class: styles['screen3-ability-2'],
  },
  {
    icon: IconAbility3,
    title: '引导力',
    desc: '不直接给答案，用递进提问驱动孩子自主推导，培养独立思考习惯。',
    class: styles['screen3-ability-3'],
  },
  {
    icon: IconAbility4,
    title: '记忆力',
    desc: '为每个孩子建立长期学情档案，每一次互动都建立在“完全了解你”的基础上。',
    class: styles['screen3-ability-4'],
  },
];

export default function Screen3() {
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen3-anim-start'],
  });
  return (
    <section className={styles['screen3-container']} ref={slideInRef.ref}>
      <h2 className={styles['screen3-title']}>四大AI教学能力</h2>
      <div className={styles['screen3-content']}>
        <div className={styles['screen3-cover-wrapper']}>
          <img src={ImgCover} alt="AI教学能力" loading="lazy" className={styles['screen3-cover']} />
          {ABILITY_LIST.map((item) => (
            <div key={item.title} className={`${styles['screen3-ability-item']} ${item.class}`}>
              <div>
                <div className={styles['screen3-ability-title']}>{item.title}</div>
                <div className={styles['screen3-ability-desc']}>{item.desc}</div>
              </div>
              <img
                src={item.icon}
                alt={item.title}
                loading="lazy"
                className={styles['screen3-ability-icon']}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
